import React, { useState, useEffect, useCallback } from "react";

import {Modal} from "antd";

import NewUserModal from "../NewUserModal/newUserModal";

import { useDispatch, useSelector } from 'react-redux';
import Http from "../../../../commons/utils/Http";
import ButtonAction from "../../../../commons/components/buttonAction";
import AccountTable from "../../../../commons/components/AccountTable";
import Message from "../../../../commons/utils/message";
import {
    accessManagementSetSelectedUser,
    accessManagementSetShowUsers,
    accessManagementSetShowUser,
} from '../../../../store/actions/accessManagementActions';

import {
    TableActions
} from './cardUsersStyles';

import DataName from "./DataName";
import DataEmails from "./DataEmails";
import DataStatus from "./DataStatus";

function CardUsers(props) {
    const dispatch = useDispatch();
    
    const userId = useSelector(state => state.userLogin.userData.id);
    const { screens } = useSelector(state => state.userLogin);
    const { selectedPartner, showUserModal } = useSelector((state) => state.accessManagement);

    const [permissions] = useState([]);
    
    const { searchPartner, filterDepartment, filterApplication } = useSelector(state => state.accessManagement);

    const [sorter, setSorter] = useState({ field: "name", order: "ascend" });
    const [filters, setFilters] = useState({});

    const [user, setUser] = useState({});
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const filterStatus = [
        {
            text: 'Ativo',
            value: 'ativo',
        },
        {
            text: 'Aguardando verificação',
            value: 'aguardando_verificacao',
        },
        {
            text: 'Temporário',
            value: 'temporario',
        },
        {
            text: 'Bloqueado',
            value: 'bloqueado',
        },
    ];

    const [lineExpandEmail, setLineExpandEmail] = useState(null);

    const tableColumns = [
        {
            title: 'Nome',
            dataIndex: 'name',
            key: 'name',
            sorter: true,
            defaultSortOrder: 'ascend',
            render: (name, user) => (
                <DataName name={name} picture={user.picture} />
            ),
        },
        {
            title: 'CPF',
            dataIndex: 'identification_number',
            key: 'identification_number',
            render: (cpf, user) => (
                <span>{ cpf? cpf : "não informado"}</span>
            ),
        },
        {
            title: 'E-mail',
            dataIndex: 'emails',
            key: 'emails',
            render: (emails, index) => (
                <DataEmails
                    list={emails}
                    line={index}
                    lineExpand={lineExpandEmail}
                    callback={() => handleExpandEmail(index)} />
            )
        },
        {
            title: 'Setor',
            dataIndex: 'dep_name',
            key: 'dep_name',
            render: (dep_name, index) => (
                <span>{dep_name}</span>
            )
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            filters: filterStatus,
            filterMultiple: false,
            render: (status) => (
                <DataStatus status={status} />
            ),
        },
        {
            title: 'Ação',
            key: 'action',
            width: '10%',
            ellipsis: true,
            align: "center",
            render: (text, record, index) => (
                <TableActions>
                    <ButtonAction type="edit" text="Editar usuário" callback={() => handleEditUser(record)} />
                    <ButtonAction type="delete" text="Excluir usuário" callback={() => handleDeleteUser(record)} />
                </TableActions>
            ),
        }
    ];

    const [tableData, setTableData] = useState([]);
    
    const defaultPagination = { current: 1, pageSize: 10 };
    const [pagination, setPagination] = useState(defaultPagination);

    const [tableLoading, setTableLoading] = useState(true);
    
    useEffect(() => {
        permissions.pop();
        if (screens.length > 0) {
            screens.map(screen => {
                if (screen.url === "/gestao-acessos") {
                    screen.functions.map(_function => {
                        if (!permissions.find(permission => permission.function_id == _function.function_id)) {
                            permissions.push(_function);
                        }
                    })
                }
            });
        }
    }, [screens]);

    function getNewFilters(filters) {
        let newFilters = filters;

        if (filterDepartment.value) {
            newFilters = { ...newFilters, id_dep: [filterDepartment.value] };
        } else {
            delete newFilters["id_dep"];
        }

        if (filterApplication.value) {
            newFilters = { ...newFilters, application_id: [filterApplication.value] };
        } else {
            delete newFilters["application_id"];
        }

        return newFilters;
    }

    useEffect(() => {
        setLineExpandEmail(null);

        let newFilters = getNewFilters(filters);
        setFilters(newFilters);

        getUsersOrSearch(pagination, newFilters, sorter, searchPartner);
    }, [searchPartner, filterDepartment, filterApplication]);

    function getUsersOrSearch(pagination, filters, sorter, search) {
        searchUsers(pagination, filters, sorter, search)
    }

    function isFiltered(filters) {
        let result = false;
        Object.keys(filters).forEach((key) => {
            if (Object.values(filters[key]).length > 0) {
                result = true;
            }
        });
        return result;
    }

    function searchUsers(pagination, filters, sorter, search) {
        const body = {
            "partner_id": selectedPartner.partner_id,
            "offset": pagination.current,
            "order": getOrder(sorter),
            "lines": pagination.pageSize,
            "search": search,
            "filters": filters,
            "access_management": true
        };

        setTableLoading(true);
        Http.post(`/users/search/userspartner`, body, Http.headers)
            .then(response => {
                const responseData = response.data
                if (!responseData.response.error) {
                    const paginationDescription = (total) => `Usuários encontrados: ${total}`;
                    setPagination({ ...pagination, total: responseData.pagination, showTotal: paginationDescription });
                    setTableData(formatTable(responseData.data));
                    setTableLoading(false);
                }
            }).catch(err => {
                setTableData([]);
                setTableLoading(false);
                setPagination(defaultPagination);
            })
    };
    
    function getOrder(sorter) {
        switch (sorter.order) {
            case 'ascend':
                return sorter.field + ' asc'
            case 'descend':
                return sorter.field + ' desc'
            default:
                return sorter.field
        }
    };

    function formatTable(data) {
        let array = [];
        data.forEach((user) => {
            user.emails = [user.email, ...user.secondary_emails];
            array.push(user)
        })
        return array;
    };

    function handleExpandEmail(index) {
        index != lineExpandEmail ? setLineExpandEmail(index) : setLineExpandEmail(null);
    }

    function handleEditUser(user) {
        dispatch(accessManagementSetShowUsers(false));
        dispatch(accessManagementSetShowUser(true));
        dispatch(accessManagementSetSelectedUser(user));
    }

    function handleOnSave() {
        getUsersOrSearch(pagination, filters, sorter, searchPartner);
    }

    function handleDeleteUser(user) {
        setTableLoading(true);
        setShowDeleteModal(true);
        setUser(user);
        getUsersOrSearch(pagination, filters, sorter, searchPartner);
        setTableLoading(false);
    }

    function handleConfirmRemovePermission() {
        removeUser(user);
        setShowDeleteModal(false);
    }

    function removeUser(data) {
        setTableLoading(true);
        
        const body = {
            "user_id": data.id,
            "partner_id": selectedPartner.partner_id,
        };
        
        Http.put(`/users/unlinkuserpartner`, body, Http.headers)
            .then(response => {
                Message.showSuccess(`Usuário desvinculado com sucesso`);
                getUsersOrSearch(pagination, newFilters, sorter, searchPartner);
            }).catch(err => {
                Message.showWarning(`Não foi possível desvincular o usuário`);
            });

        setLineExpandEmail(null);

        let newFilters = getNewFilters(filters);
        setFilters(newFilters);
        getUsersOrSearch(pagination, newFilters, sorter, searchPartner);

        setTableLoading(false);
    }

    function handleCancelDeleteUser() {
        setUser({});
        setShowDeleteModal(false);
        setTableLoading(false);
    }

    const removePermissionModal = () => (
        <Modal visible={showDeleteModal} title="Remover todas as permissões"
               onCancel={handleCancelDeleteUser} cancelText="Cancelar" onOk={handleConfirmRemovePermission} okText="Excluir"
               okType="danger">

            <p>Você realmente deseja remover todas as permissões do usuário <strong>{user.name? user.name : user.email}</strong> da empresa <strong>{selectedPartner.company_name}</strong>?</p>
            <small><strong><p>Após concluída, essa ação não poderá ser desfeita.</p></strong></small>
        </Modal>
    );

    function handleOnChangeTable(paginationTable, filtersTable, sorterTable, currentPageData) {
        const mergedFilters = Object.assign(filters, filtersTable);

        Object.keys(mergedFilters).forEach((key) => {
            if (!mergedFilters[key]) {
                delete mergedFilters[key]
            }
        });

        setSorter(sorterTable);
        setFilters(mergedFilters);
        getUsersOrSearch(paginationTable, mergedFilters, sorterTable, searchPartner);
    }

    return (
        <>
            {removePermissionModal ()}

            <AccountTable
                columns={tableColumns}
                dataSource={tableData}
                pagination={pagination}
                loading={tableLoading}
                onChange={handleOnChangeTable}
            />
            {showUserModal ? <NewUserModal onSave={handleOnSave} /> : null}
        </>
    )
}

export default CardUsers;